export function TextareaToolbar({ children }) {
  return <div className="flex justify-end items-center mb-2 gap-3">{children}</div>
}
